import { Coins, ScrollText, Shield, Swords, UserSquare, type LucideIcon } from 'lucide-react';

// Primary navigation structure mirrors the WordPress theme's default menu.
export interface NavLink {
  label: string;
  to: string;
}
export interface NavGroup {
  label: string;
  icon: LucideIcon;
  to?: string;
  links?: NavLink[];
}

export const PRIMARY_NAV: NavGroup[] = [
  {
    label: 'Gold & Items',
    icon: Coins,
    links: [
      { label: 'Buy & Sell Gold', to: '/services/gold' },
      { label: 'Buy Items & Bonds', to: '/services/items' },
    ],
  },
  { label: 'Accounts', icon: UserSquare, to: '/services/accounts' },
  {
    label: 'Combat',
    icon: Swords,
    links: [
      { label: 'PVM Services', to: '/services/pvm' },
      { label: 'Minigames', to: '/services/minigames' },
    ],
  },
  {
    label: 'Quests & Diaries',
    icon: ScrollText,
    links: [
      { label: 'Quests', to: '/services/quests' },
      { label: 'Achievement Diaries', to: '/services/diaries' },
      { label: 'Combat Achievements', to: '/services/combat-achievements' },
    ],
  },
  {
    label: 'Skilling & Gathering',
    icon: Shield,
    links: [
      { label: 'Skilling', to: '/services/skilling' },
      { label: 'Ironman Gathering & Misc', to: '/services/ironman-gathering' },
    ],
  },
];
